import React from 'react';
import { ProductFormManager } from '../event-fields/ProductFormManager';
import { EventRefundSettings } from '../event-fields/EventRefundSettings';

/**
 * Event Products Tab — refund settings first, then products/tickets.
 */
export const EventProductsTab = ({ eventType, isEdit = false, record = {} }) => {
  return (
    <React.Fragment>
      <EventRefundSettings />
      <div style={{ marginTop: 24, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
        <ProductFormManager
          eventType={eventType}
          disabled={isEdit}
          isEdit={isEdit}
          record={record}
        />
      </div>
    </React.Fragment>
  );
};
